import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { debugLinkedInQueryKeys } from './queryKeys';

interface Variables {
  messageId: string;
}

export function useDebugLinkedInSendNowMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ messageId }: Variables) => {
      const { data } = await fetchClient.POST(
        '/debug/linkedin/messages/{messageId}/send-now',
        { params: { path: { messageId } } },
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: debugLinkedInQueryKeys.all });
    },
  });
}
